<template>
    <component
        :is="tag"
        class="sim-card"
        :class="{
            'sim-card--floating': floating && !skeleton,
            'sim-card--hover': hover && !skeleton,
            'sim-card--even': even,
            'sim-card--sm': small,
            'sim-card--md': medium,
            'sim-card--lg': large,
            'sim-card--xl': extraLarge,
            'sim-card--skeleton': skeleton,
        }"
    >
        <header v-if="$slots.header" class="sim-card__header">
            <slot name="header" />
            <hr>
        </header>

        <BaseUiSkeleton v-if="skeleton"
                        class="!visible absolute inset-0"
                        :color="typeof skeleton === 'boolean' ? undefined : skeleton"
        />

        <slot />
    </component>
</template>

<script lang="ts" setup>
import type { BaseUiSkeletonColors } from '../../base/BaseUiSkeleton.vue'

const {
    tag = 'div',
    small,
    medium,
    large,
    extraLarge,
    floating,
    hover,
    even,
    skeleton,
} = defineProps<{
    tag?: 'div' | 'li' | 'aside'
    small?: boolean
    medium?: boolean
    large?: boolean
    extraLarge?: boolean
    floating?: boolean
    hover?: boolean
    even?: boolean
    skeleton?: boolean | BaseUiSkeletonColors
}>()

</script>

<style lang="scss" scoped>

.sim-card {
    background-color: $sim-c-card;
    border-radius: $sim-border-radius-sm;
    padding: 0.75rem 1rem;
    box-sizing: border-box;
}

.sim-card--even {
    padding: 1rem;
}

.sim-card--floating {
    background-color: $sim-c-white;
    box-shadow: $sim-shadow;
}

.sim-card--sm {
    padding: 0.5rem 0.75rem;
    border-radius: $sim-border-radius-xs;
}

.sim-card--even .sim-card--sm {
    padding: 0.75rem;
}

.sim-card--md {
    padding: 1rem 1.5rem;
}

.sim-card--even .sim-card--md {
    padding: 1.5rem;
}

.sim-card--lg {
    padding: 1.75rem;
}

.sim-card--even .sim-card--lg {
    padding: 2rem;
}

.sim-card--xl {
    padding: 0.75rem 1.25rem;

    @include more-than(lg) {
        padding: 1.875rem 1.25rem 1.25rem;
    }
}

.sim-card--hover {
    transition: transform $sim-trans-time-long $sim-timing;
    transform: translateY(0);

    @include mouse-hover {
        transform: translateY(-0.25rem);
    }
}

.sim-card--skeleton {
    position: relative;
    color: transparent;

    cursor: wait;

    & > * {
        visibility: hidden;
    }
}

</style>
